export default {
  hello: '你好',
  welcome: '欢迎来到我们的网站'
};